'use client';

import { RowRange } from 'design-system/client';
import type { FeedDonation } from 'indexed-db';
import { createContext, useContext } from 'react';
type ProgressAndDonationsContextType = {
  fundraisingEventId: string;
  donations: FeedDonation[];
  donationCount: number | null;
  donationAmountSum: number | null;
  /** Donation feed window offset */
  offset: number;
  /** Current (loaded) row in the donation feed window */
  row: number;
  /** Current (requested) row in the donation feed window */
  requestedRow: number;
  /** Callback to handle scroll events */
  onScroll: (range: RowRange) => void;
  /** How many new unseen donations are above on top of the list */
  newDonationsOffset: number;
  /** How many new donations from the beginning */
  totalDonationOffset: number;
};
const ProgressAndDonationsContext = createContext<ProgressAndDonationsContextType>({
  fundraisingEventId: '',
  donations: [],
  donationCount: null,
  donationAmountSum: null,
  offset: 0,
  row: 0,
  onScroll: () => {},
  newDonationsOffset: 0,
  requestedRow: 0,
  totalDonationOffset: 0
});
function useProgressAndDonationsContext() {
  return useContext(ProgressAndDonationsContext);
}
const ProgressAndDonationsProvider = ProgressAndDonationsContext.Provider;
export { ProgressAndDonationsContext, useProgressAndDonationsContext, ProgressAndDonationsProvider };